const todoActionTypes = 
{
    ADD_TODO: 'ADD_TODO',
    REMOVE_TODO: 'REMOVE_TODO',
    TOGGLE_TODO: 'TOGGLE_TODO',
    REMOVE_DONE_TODOS: 'REMOVE_DONE_TODOS'
}

export default todoActionTypes;



// WEBPACK FOOTER //
// ./src/modules/todoMain/actions/todo/todoActionTypes.js